<template>
    <div id="gallery-container" class="ms-4 mt-1 mb-4">

        <view-header v-if="showHeader" :table="table" :view="view" :parent-table="parentTable"
                     :parent-document="parentDocument"></view-header>

        <div class="row mx-2 mt-4" v-for="gridRow in gridRows">
            <div v-for="document in gridRow" class="col-md-4 col-sm-12 mb-1">
                <router-link :to="detailsRoute(document['id'])">

                    <!-- Render a custom view -->
                    <div v-if="view.layout && view.layout.rows" class="card shadow-sm h-100">
                        <div class="card-body">
                            <row-renderer v-for="(row, index) in view.layout.rows"
                                    :layout="view.layout" :key="index + view.id + 'row'"
                                          :row="row" :index="index" :document="document"
                                          :table="table" :view="view"></row-renderer>
                        </div>
                    </div>

                    <div v-else class="card shadow-sm h-100">

                        <img v-if="attachment && getFeaturedImage(document)" :src="getFeaturedImage(document)"
                             class="card-img-top">

                        <div class="card-body">
                            <h5 class="card-title">
                                {{fieldValue(document, primaryField)}}
                            </h5>

                            <select-view v-if="selectField" :document="document"
                                         :field="selectField"></select-view>

                            <p v-if="textField" v-html="fieldValue(document, textField)" class="card-text"></p>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>

    </div>
</template>

<script>
    import ViewService from "../../services/ViewService";
    import SelectView from "../../components/SelectView.vue";
    import ViewHeader from "../ViewHeader.vue";

    export default {
        name: 'GalleryView',
        components: {ViewHeader, SelectView},
        props: {
            view: Object,
            table: Object,
            parentTable: Object,
            parentDocument: Object,
            showHeader: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                model: webase.model,
                records: []
            }
        },
        computed: {
            primaryField() {
                return webase.utils.table.getPrimaryField(this.table)
            },
            gridRows() {
                return webase.utils.array.listToGrid(this.records, 3)
            },
            attachment() {
                let field = webase.utils.table.getAttachmentField(this.table)
                return field
            },
            textField() {
                return webase.utils.table.getTextField(this.table)
            },
            selectField() {
                return webase.utils.table.getSelectField(this.table)
            }
        },
        mounted() {
            this.loadData()
            webase.eventDispatcher.on('viewUpdated', this.loadData)
        },
        beforeUnmount() {
            webase.eventDispatcher.off('viewUpdated', this.loadData)
        },
        methods: {
            loadData() {
                let viewService = new ViewService()

                viewService.getData(this.view, this.table).then((response) => {
                    this.records = response
                }).catch((message) => {
                    console.log('error loading data from table')
                    console.log(message)
                })
            },
            fieldValue(document, field) {
                return document[field.index]
            },
            getFeaturedImage(record) {
                let attachmentData = record[this.attachment.index]

                if (attachmentData === undefined || attachmentData === null || attachmentData.length === 0) {
                    return null
                }

                console.log('getFeaturedImage')
                console.log()

                let firstAttachment = attachmentData[0]

                if (!webase.utils.table.isImage(firstAttachment)) {
                    return null
                }

                let featureImageUrl = firstAttachment.url
                // console.log(featureImageUrl)
                return featureImageUrl
            },
            detailsRoute(documentId) {

                if (webase.utils.table.hasDetailsView(this.table)) {
                    let detailsView = webase.utils.table.getDetailsView(this.table)
                    return {name: 'details-view', params: {view_id: detailsView.id, record_id: documentId}}
                }

                return {name: 'static-details', params: {table_id: this.table.id, record_id: documentId}}
            }
        }
    }
</script>

<style>

</style>
